import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { FaireDateRange } from "./FaireDateRange";
/**
 * {@link FaireDateRange} mutable counterpart.
 *
 * Allows undefined start and end dates to account for cases
 * when the user is entering date ranges. However, properly defined
 * data range should have a defined start range, see {@link toImmutableIfValid}.
 */ export var MutableFaireDateRange = function MutableFaireDateRange(startDate, endDate) {
    "use strict";
    var _this = this;
    _class_call_check(this, MutableFaireDateRange);
    this.startDate = startDate;
    this.endDate = endDate;
    /** Convert to immutable if the range is valid. */ this.toImmutableIfValid = function() {
        if (!!_this.startDate && !!_this.endDate) {
            return new FaireDateRange(_this.startDate, _this.endDate);
        }
        return;
    };
};
